module.exports = __webpack_public_path__ + "static/img/6.202e3ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/img/6.png
// module id = 9jEj
// module chunks = 0